import { render, staticRenderFns } from "./PrivacyAccessHistories.vue?vue&type=template&id=2f203bf9&"
import script from "./PrivacyAccessHistories.vue?vue&type=script&lang=ts&"
export * from "./PrivacyAccessHistories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports